export enum RouteNames {
  HOME = '/',
  LOGIN = '/login',
  AUTOMATIC_LOGIN = '/automatic-login',
  AUTHENTICATE = '/auth',
  PROFILE = '/profile',
  SINGLE_ARTICLE = '/article',
  ARTICLE = '/article/:guid',
  VARIATION = '/variation/:id',
  MY_VARIATIONS = '/my-variations',
  STATISTICS_DASHBOARD = '/statistics-dashboard',
  TIP = "/tip/:id",
  SINGLE_TIP = "/tip",
  TIP_VARIATION = '/tip-variation/:id',
  SINGLE_TIP_VARIATION = '/tip-variation'
}
